import React from 'react';

interface ButtonProps {
  onClick?: (e: any, index: number, form: string) => void;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  index?: number;
  form?: string;
}

const Button: React.FC<ButtonProps> = (props) => {
  const { className, children, onClick, index, form } = props;

  return (
    <button
      type="button"
      className={className}
      {...props}
      onClick={(e) => {
        if (onClick) {
          onClick(e, index, form);
        }
      }}
    >
      {children}
    </button>
  );
};

export default Button;
